import { render, staticRenderFns } from "./CustomerCustomFieldsCard.vue?vue&type=template&id=a7e2b91c&"
import script from "./CustomerCustomFieldsCard.vue?vue&type=script&lang=js&"
export * from "./CustomerCustomFieldsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports